import {post} from '@iflat/iflat-ui/src/api/methods'

export default {
  async login (data) {
    const res = await post(`/auth/login`, data, {statusesWithoutInterceptor: [401]})
    return res.data
  },
  async logout() {
    const res = await post(`/auth/logout`)
    return res.data
  },
  async passwordReset (data) {
    const res = await post(`/auth/passwordReset`, data)
    return res.data
  },
  async checkPhone (phone) {
    const res = await post('/auth/checkUsers', { phone })
    return res.data
  },
  async sendSmsCode ({ data, params }) {
    const res = await post(`/auth/smsCode`, data, params)
    return res.data
  },
  async smsCodeCheck (data) {
    const res = await post(`/auth/smsCodeCheck`, data)
    return res.data
  },
  async registration (data) {
    const res = await post(`/auth/register`, data)
    return res.data
  },
  async refreshToken() {
    const res = await post(`/auth/refresh`)
    return res.data
  }
}